import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "@/lib/constants";

export function ConfirmationMessage({ message, testId = "confirmation-message" }) {
    return (
        <div
            className="a1-card a1-bg-alt flex flex-col gap-3 items-start"
            role="status"
            data-testid={testId}
        >
            <CheckCircle2 size={32} style={{ color: "var(--color-success)" }} />
            <h3 className="text-2xl">Thanks — we got it.</h3>
            <p className="text-[var(--color-text)]">{message}</p>
            <p className="text-sm text-[var(--color-text-muted)]">
                If your situation is urgent (HOA deadline, storm damage), please also call us at{" "}
                <a href={`tel:${BUSINESS.phoneTel}`}>{BUSINESS.phone}</a> so we can move you up the list.
            </p>
            <p className="text-sm">— John & the A1 Screening team</p>
            <Link to="/" className="a1-btn-secondary mt-2">Back to home</Link>
        </div>
    );
}

export function ErrorMessage({ message, testId = "error-message" }) {
    return (
        <div
            className="a1-card border-[var(--color-danger)] flex flex-col gap-2"
            role="alert"
            data-testid={testId}
        >
            <AlertCircle size={28} style={{ color: "var(--color-danger)" }} />
            <h3 className="text-xl">Hmm — that didn't go through.</h3>
            <p>{message || "Please try again. If it still doesn't work, just call or email us and we'll take it from there."}</p>
            <p className="text-sm text-[var(--color-text-muted)]">
                <a href={`tel:${BUSINESS.phoneTel}`}>{BUSINESS.phone}</a> ·{" "}
                <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>
            </p>
        </div>
    );
}

export function LoadingState({ label = "Loading…", testId = "loading-state" }) {
    return (
        <div className="flex items-center gap-2 text-[var(--color-text-muted)]" data-testid={testId}>
            <Loader2 className="animate-spin" size={18} /> {label}
        </div>
    );
}

export function EmptyState({ headline = "Nothing here yet.", body, testId = "empty-state" }) {
    return (
        <div className="a1-card a1-bg-alt text-center py-8" data-testid={testId}>
            <h4 className="text-lg mb-1">{headline}</h4>
            {body ? <p className="text-sm text-[var(--color-text-muted)]">{body}</p> : null}
        </div>
    );
}
